// extracted by mini-css-extract-plugin
module.exports = {"wrap":"UserScrollMenu_wrap__2hqqm","listItem":"UserScrollMenu_listItem__3Y71P","link":"UserScrollMenu_link__1HPYp","active":"UserScrollMenu_active__7adXH"};